import { Link } from "react-router-dom";

const SRC = { light: "/assets/logo-horsepower.png", dark: "/assets/logo-horsepower-noir.png", white: "/assets/logo-horsepower-blanc.png" };

export default function Logo({ variant = "light", className = "", imgClass = "h-10 lg:h-12" }) {
  return (
    <Link to="/" className={`flex items-center ${className}`} data-testid="logo-link">
      <img src={SRC[variant] || SRC.light} alt="Horsepower Garage" className={`${imgClass} w-auto`} width="1864" height="399" />
    </Link>
  );
}
